import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface State {
  isOpen: boolean
  toggle(state?: boolean): void
  theme: 'light' | 'dark'
  setTheme(theme?: 'light' | 'dark'): void
}

export const useUserPreference = create<State>()(
  persist(
    (set) => ({
      isOpen: false,
      toggle(s) {
        set((state) => ({
          isOpen: typeof s === 'boolean' ? s : !state.isOpen,
        }))
      },
      theme: 'light',
      setTheme(theme) {
        set(() => ({
          theme,
        }))
      },
    }),
    {
      name: 'preference',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
